import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            为什么动漫爱好者选择羞羞动漫网站
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 md:p-7 bg-background-50 rounded-2xl border border-background-200/60 text-center hover:border-primary-200 cursor-default transition-all duration-200"
            >
              <div className="w-16 h-16 mx-auto rounded-2xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}